import { defineMessages } from 'react-intl';

export const studiesTranslations = defineMessages({
    atLeastOne: {
        id: 'Education.form.validation.atLeastOne',
        defaultMessage: "Fill at least one study reference, even if you're self taught."
    }
});
